<template>
	<div class="formTabWrapper">
		<div class="formTabCard">
			<field
					v-if="trailerTypeId === 2"
					width="170px"
					margin="0"
					label="Hours"
					isReadonly
					tooltip="Hours from last WO"
					:setInputValue="hours"
					isNumber
					type="number"
			></field>
			<field
					width="220px"
					margin="0"
					label="Origin value"
					placeholder="Enter value"
					icon="dollar"
					:setInputValue="originValue"
					isNumber
					type="number"
					:isDisabled="getPermissionAction"
					@updateInput="onInput($event, 'originValue')"
			></field>
		</div>

		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Timeline</div>
				<div class="formTabTableWrap_top-add">

					<v-btn
							:disabled="getPermissionAction" @click="onRenewalValuePopupHandler(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add truck value</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">
				<renewal-value
						v-if="trailersValueFilter"
						:filter="trailersValueFilter"
						:items="trailersValueList"
						:trailerId="trailerId"
						:getPermissionAction="getPermissionAction"
						@updateEdit="onEdit"
						@updateRemoveItem="setRemoveItem"
				></renewal-value>
			</div>
		</div>

		<renewal-value-popup
				v-if="isRenewalValuePopup"
				@updateRenewalValueList="onRenewalValueList"
				@updateClose="onRenewalValuePopupHandler(false)"
				:trailerNumber="trailerNumber"
				:editItem="editItem"
				:itemsYears="trailersValueYears"
				:originValue="originValue"
		></renewal-value-popup>
		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="isRemove = false"
		></remove-block>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import RenewalValue from "@/components/Maintenance/Trailers/TrailersForm/RenewalValue/RenewalValue";

// async components
const RenewalValuePopup =
    () => import("@/components/Maintenance/Trailers/TrailersForm/RenewalValuePopup/RenewalValuePopup");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "FifthTab",
	components: {
		RenewalValue,
		RenewalValuePopup,
		RemoveBlock
	},
	props: {
		trailerId: Number,
		trailerTypeId: Number,
		trailerNumber: String,
		hours: String,
		originValue: [ Number, String ],
		getPermissionAction: Boolean,
	},
	data: () => ({
		isRenewalValuePopup: false,
		editItem: null,
		isRemove: false,
		removeItem: null
	}),
	computed: {
		...mapGetters([ 'trailersValueFilter', 'trailersValueList', 'trailersValueYears' ]),
	},
	methods: {
		...mapActions([
			'onTrailersValueEdit',
			'onTrailersValue',
			'onTrailersValueRemove',
			'onTrailersValueCreate',
		]),
		onInput({ value }, key) {
			// Сделать проверку
			this.$emit('updateValueTab', { value, key });
		},
		async onEdit(item) {
			this.editItem = await this.onTrailersValueEdit(item.id);
			this.isRenewalValuePopup = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { trailerId: this.trailerId, id };
			this.isRemove = true;
		},
		onRenewalValuePopupHandler(value) {
			this.isRenewalValuePopup = value;
			if (!value) this.editItem = null;
		},
		async onRemoveItem() {
			await this.onTrailersValueRemove(this.removeItem);
			this.isRemove = false;
		},
		async onRenewalValueList(values) {
			await this.onTrailersValueCreate({ trailerId: this.trailerId, values });
		}
	},
	async mounted() {
		await this.onTrailersValue(this.trailerId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabCard.scss";
@import "@/assets/style/components/formTab/formTabCard";
@import "@/assets/style/components/formTab/formTabTableWrap";
.formTabCard {
	display:  flex;
	align-items:  center;
	gap: 10px;
}

</style>
